$(document).ready(function () {

  var coverage, undertone, shade, variant;
  var shade_match = JSON.parse(document.querySelector('#shade-match').textContent);

  $(".single-selection").click(function (e) {
    $(this)
      .closest(".optionBox")
      .find(".single-selection")
      .removeClass("active");
    $(this).addClass("active");

    

    var name = $(this).find("input").data("result");
    if (name != undefined) {
      updateResults();
    }
    
  });

  function updateResults() {

    let quiz_result_url_location = '/pages/quiz-result-greens/';
    let split_test_result_url_location = document.body.getAttribute('data-quiz-result-greens-location');

    if (split_test_result_url_location) {
      if (split_test_result_url_location.length > 0) {
        quiz_result_url_location = split_test_result_url_location;
      }
    }

    const savedSelectedFrustratingIssues = JSON.parse(localStorage.getItem("selectedFrustratingIssues")) || [];
    const optionsForFrustratingUrl = savedSelectedFrustratingIssues.join('+').toLowerCase().replace(/\/|\s+|\\/g, (match) => (match === '/' ? ':' : '-'));

    const savedSelectedDealingIssues = JSON.parse(localStorage.getItem("selectedDealingIssues")) || [];
    const optionsForDealingUrl = savedSelectedDealingIssues.join('+').toLowerCase().replace(/\/|\s+|\\/g, (match) => (match === '/' ? ':' : '-'));

    //console.log("Separated issues result: ", optionsForFrustratingUrl);
    //console.log("Separated Dealing result: ", optionsForDealingUrl);

    $("#quiz_result_url").val(`https://${window.location.hostname}${quiz_result_url_location}${optionsForFrustratingUrl}&issue=${optionsForDealingUrl}`);

  }

  $(".multi-selection").click(function (e) {
    const $tabGroup = $(this).closest(".question-Box"); // Use .question-Box as the container
    const maxActiveTabs = $tabGroup.attr("max-active-tabs") ? parseInt($tabGroup.attr("max-active-tabs"), 15) : 15;
    const $activeTabs = $tabGroup.find(".multi-selection.active");
  
    // Toggle active state
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
    } else {
      // Only add active if max limit is not reached
      if ($activeTabs.length < maxActiveTabs) {
        $(this).addClass("active");
      }
    }
  
    // Check active count and disable/enable tabs as needed
    if ($tabGroup.find(".multi-selection.active").length >= maxActiveTabs) {
      $tabGroup.find(".multi-selection:not(.active)").addClass("disabled");
    } else {
      $tabGroup.find(".multi-selection.disabled").removeClass("disabled");
    }
  });
  
  

  $(".comn-btn").click(function (e) {
    $("html, body").animate({ scrollTop: 0 }, "slow"); 

    if ($(this).closest(".greens-frustrating-issues")) {
      let selectedFrustratingIssues = [];

      $('.greens-frustrating-issues .active input').each(function() {
        selectedFrustratingIssues.push($(this).val());
      });

      selectedFrustratingIssues = selectedFrustratingIssues.slice(0, 3);
      localStorage.setItem("selectedFrustratingIssues", JSON.stringify(selectedFrustratingIssues));
    }


    if ($(this).closest(".greens-dealing-issues")) {
      let selectedDealingIssues = [];

      $('.greens-dealing-issues .active input').each(function() {
        selectedDealingIssues.push($(this).val());
      });

      selectedDealingIssues = selectedDealingIssues.slice(0, 3);
      localStorage.setItem("selectedDealingIssues", JSON.stringify(selectedDealingIssues));

    }

    if ($(this).hasClass('btn_final')) {
      //console.log('btn_final');
      return;
    }

    if (
      $(this)
        .closest(".step-5 .optionBox")
        .find(".single-selection")
        .hasClass("active")
    ) {
      $(this).closest(".question-Box").hide();
      $(".step-6").show();
      stepDataLayer(this);
    } else if ($(this).hasClass("shade-help")) {
      var selectedUndertone = this.getAttribute('data-undertone-value');

      if (selectedUndertone) {
        $(`[data-result="question_5"][data-value="${selectedUndertone}"]`)
        .attr("checked", "checked");
        undertone = selectedUndertone;
        updateResults();
      }

      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else if ($(this).hasClass("novalidate")) {
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else if (this.getAttribute('data-quiz-step') === '0') {
      //console.log('Step 0');
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").next(".question-Box").fadeIn();
      stepDataLayer(this);
    } else {
      if (
        $(this)
          .closest(".optionBox")
          .find(".single-selection, .multi-selection")
          .hasClass("active")
      ) {
        $(this).closest(".question-Box").hide();
        $(this).closest(".question-Box").next(".question-Box").fadeIn();
        stepDataLayer(this);
      } else {
        $(this).closest(".mob-bottom").find(".error-msg").fadeIn();
      }
    }

    progress();
  });

  $(".pop-nextBtn").click(function (e) {
    $(this).closest(".question-Box").hide();
    $(".step-6").fadeIn();
    stepDataLayer(this);
    progress();
  });

  $(".nextSelection").click(function (e) {
    $(this).closest(".question-Box").hide();
    $(this).closest(".question-Box").next(".question-Box").fadeIn();
    stepDataLayer(this);
    progress();
  });

  $(".btn-back").click(function () {
    if ($(this).closest(".question-Box").hasClass("step-6")) {
      if (
        $(this)
          .parents()
          .find(".step-3")
          .find(".coverage-row")
          .hasClass("active")
      ) {
        $(".question-Box.step-5").show();
        $(".question-Box.step-6").hide();
      } else {
        $(this).closest(".question-Box").hide();
        $(this).closest(".question-Box").prev(".question-Box").fadeIn();
        $(".error-msg").hide();
        progress();
        $(".pop-body").fadeOut();
      }
    } else {
      $(this).closest(".question-Box").hide();
      $(this).closest(".question-Box").prev(".question-Box").fadeIn();
      $(".error-msg").hide();
      progress();
      $(".pop-body").fadeOut();
      $(".colorlight, .colordark").show();
    }
    if ($(this).closest('.question-Box').prev('.question-Box').hasClass('step-1')) $('.banner-quiz').show();
  });

  $('[data-result="question_5"]').change(function(e) {
    $("#" + this.getAttribute('data-value') + "-popup").fadeIn();
  });

  $(".get-popup1").click(function (e) {
    $("#cool-popup").fadeIn();
  });

  $(".get-popup2").click(function (e) {
    $("#warm-popup").fadeIn();
  });

  $(".get-popup3").click(function (e) {
    $("#neutral-popup").fadeIn();
  });

  $(".closePop").click(function (e) {
    $(".pop-body").fadeOut();
  });

  var quizForm = document.querySelector('#quiz-form');
  if (quizForm) {
    quizForm.addEventListener('submit', formSubmit);
  }

  initLogosSlider();
});

function formSubmit(evt) {
  evt.preventDefault();
  //console.log('formSubmit');

  const properties = {};
  const formData = new FormData(this);


  // First loop to collect form data
  for (const [key, value] of formData.entries()) {
    // Check if the key already exists in properties
    if (properties[key]) {
      // If it exists and is already an array, push the new value
      if (Array.isArray(properties[key])) {
        properties[key].push(value);
      } else {
        // Convert the single existing entry into an array if it's not already
        properties[key] = [properties[key], value];
      }
    } else {
      // If it's the first entry for this key, add it as a single value
      properties[key] = value;
    }
  }

  // Add missing options for the specific question if fewer than 3 values are present
  const questionKey = "[DG] What issues are most frustrating you lately?";
  if (Array.isArray(properties[questionKey])) {
    while (properties[questionKey].length < 3) {
      properties[questionKey].push(""); // Add blank entries
    }
  } else if (!properties[questionKey]) {
    // Initialize with three blank options if the key does not exist at all
    properties[questionKey] = ["", "", ""];
  } else {
    // If there's a single entry, convert it to an array and add blanks to make three
    properties[questionKey] = [properties[questionKey], "", ""];
  }

  // Second loop to assign "Option" labels for the specified question
  if (Array.isArray(properties[questionKey])) {
    properties[questionKey].forEach((item, index) => {
      properties[`${questionKey} Option ${index + 1}`] = item;
    });
    delete properties[questionKey]; // Remove the original array entry
  }


  console.log('properties', properties);

  // Store the email in localStorage
  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    localStorage.setItem("quizUserEmail", properties.email); // Store valid email in localStorage
  } else {
    localStorage.setItem("quizUserEmail", ''); // Set empty string if no email is present or invalid
  }


  if (properties.email && properties.email !== '' && isEmail(properties.email)) {
    document.body.classList.add('loading');
    $('.quiz-email__error').hide();
    
    abstractEmail(properties.email)
      .then(response => response.json())
      .then(response => {
        if (response.deliverability === "DELIVERABLE") {
          klaviyoIdentify(properties);
        } else {
          identifyCallback(properties.email);
        }
      });
  } else {
    if ($('.quiz-email__input').val() == '') {
      $('.quiz-email__error').show();
      $('.quiz-email__error').html('Enter your email above');
    } else if ($('.quiz-email__input').val() != '' && !isEmail($('.quiz-email__input').val())) {
      $('.quiz-email__error').show();
      $('.quiz-email__error').html('Please enter valid email address');
    }
    return false;
  }
}

function abstractEmail(email) {
  const options = {method: 'GET'};
  const ABSTRACT_API_KEY = '271838bd67234b17906a3c1f580b10a6';
  const requestURL = `https://emailvalidation.abstractapi.com/v1?api_key=${ABSTRACT_API_KEY}&email=${email}`;
  const abstractRequest = fetch(requestURL, options)
    .catch(err => console.error(err));
  
  return abstractRequest;
}

async function klaviyoIdentify(properties) {
  let companyID = 'WVhPzg';
  let listID = 'TT9GFd';

  if (window.location.hostname === 'fieracosmetics.co.uk') {
    companyID = 'WVhPzg';
    listID = 'TT9GFd';
  } else if (window.location.hostname === 'fieracosmetics.com') {
    companyID = 'HEyw3X';
    listID = 'TT9GFd';
  }

  const options = {
    method: 'POST',
    headers: {revision: '2025-01-15', 'content-type': 'application/json'},
    body: JSON.stringify({
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'GreensQuiz',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: properties.email,
                properties: properties
              }
            }
          }
        },
        relationships: {
          list: {
            data: {
              type: 'list', id: listID
            }
          }
        }
      }
    })
  };

  try {
    await fetch(`https://a.klaviyo.com/client/subscriptions/?company_id=${companyID}`, options);
  } catch (error) {
    console.error(error);
  } finally {
    identifyCallback(properties.email);
  }
}

function identifyCallback(email) {
  window.dataLayer = window.dataLayer || [];
  dataLayer.push({
    event: "quiz_lead",
    email: email
  });

  if (window.TriplePixel) {
    TriplePixel("Contact", {email: email});
  }

  let quiz_result_url_location = '/pages/quiz-result-greens/';
  let split_test_result_url_location = document.body.getAttribute('data-quiz-result-greens-location');

  if (split_test_result_url_location) {
    if (split_test_result_url_location.length > 0) {
      quiz_result_url_location = split_test_result_url_location;
    }
  }

  // window.location.href = '/pages/quiz-result/' + shade_name.toLowerCase() + '+' + shade_id + '+' + coverage;
  const savedSelectedFrustratingIssues = JSON.parse(localStorage.getItem("selectedFrustratingIssues")) || [];
  const optionsForFrustratingUrl = savedSelectedFrustratingIssues.join('+').toLowerCase().replace(/\/|\s+|\\/g, (match) => (match === '/' ? ':' : '-'));

  const savedSelectedDealingIssues = JSON.parse(localStorage.getItem("selectedDealingIssues")) || [];
  const optionsForDealingUrl = savedSelectedDealingIssues.join('+').toLowerCase().replace(/\/|\s+|\\/g, (match) => (match === '/' ? ':' : '-'));

  //console.log("Separated issues: ", optionsForFrustratingUrl);
  //console.log("Separated Dealing: ", optionsForDealingUrl);

  
  document.body.classList.remove('loading');
  $('.success_msg').show();
  setTimeout(() => {
    window.location.href = `${quiz_result_url_location}${optionsForFrustratingUrl}&issue=${optionsForDealingUrl}`;
  }, 1000);
}

function stepDataLayer(button) {
  const stepNumber = button.getAttribute('data-quiz-step');
  const stepQuestion = button.getAttribute('data-quiz-question');

  //console.log('stepNumber', stepNumber);
  //console.log('stepQuestion', stepQuestion);

  if (stepNumber && stepQuestion) {
    window.dataLayer = window.dataLayer || [];
    const dataLayerObject = {
      event: "quiz_progress",
      step: stepNumber,
      question: stepQuestion
    };
    if (parseInt(stepNumber, 10) >= 1) $(".banner-quiz").hide();
    else $(".banner-quiz").show();
    dataLayer.push(dataLayerObject);
  }
}

function progress() {
  var progressVal = $(".question-Box:visible").attr("data-wdth");
  $(".prgress-1").css("width", progressVal + "%");
  if (progressVal == 98) {
    progressbar();
  }
}

var id = 0;
function progressbar() {
  var elem = document.getElementById("analyzeProgress");
  var width = 1;
  id = setInterval(frame, 60);
  function frame() {
    if (width >= 100) {
      clearInterval(id);
      window.setTimeout(function () {
        $(".step-16").hide();
        $(".step-17").fadeIn();
      }, 100);
    } else {
      width++;
      elem.style.width = width + "%";
    }

    $(".progVal").html(width + "%");
  }
}


function isEmail(email) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(email);
}

function initLogosSlider() {
  //console.log('initLogosSlider()');
  const swiper = new Swiper('#quiz-logos-swiper', {
    loop: true,
    speed: 3000,
    autoplay: {
      delay: 0
    },
    freeMode: {
      enabled: true,
      sticky: false,
    },
    centeredSlides: false,
    slidesPerView: 3,
    spaceBetween: 10,
    breakpoints: {
      400: {
        slidesPerView: 4
      },
      600: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      700: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      750: {
        slidesPerView: 4,
        spaceBetween: 10
      },
      850: {
        slidesPerView: 5,
        spaceBetween: 10
      },
      950: {
        slidesPerView: 6,
        spaceBetween: 10
      },
      1050: {
        slidesPerView: 7,
        spaceBetween: 10
      }
    }
  });
  
}